import { useEffect, useState } from "react";
import axios from "axios";
import staticLinks from "@/data/blog-links.json";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Returns the freshest blog-link map: live-synced (Mongo, refreshed nightly by
 * the backend APScheduler job) if available, else the static baseline shipped
 * in the build. Never returns undefined.
 */
export function useBlogLinks() {
  const [map, setMap] = useState(staticLinks);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/blog-links`)
      .then((r) => {
        if (cancelled) return;
        const live = r?.data?.map;
        if (live && live.serviceRelated) {
          // Merge: live wins per key, static provides fallback for any missing slug
          setMap({
            blogOrigin: live.blogOrigin || staticLinks.blogOrigin,
            guidesLabel: live.guidesLabel || staticLinks.guidesLabel,
            homeLatest: (live.homeLatest && live.homeLatest.length)
              ? live.homeLatest
              : staticLinks.homeLatest,
            serviceRelated: {
              ...staticLinks.serviceRelated,
              ...live.serviceRelated,
            },
          });
        }
      })
      .catch(() => {
        // Static fallback already set — silent
      });
    return () => { cancelled = true; };
  }, []);

  return map;
}
